(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jdm-popular-picks"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => {
    const summary = document.querySelector('[data-jdm-review-summary]');
    if (!summary) return;
    let sourceObserver;
    const update = () => {
      const source = document.querySelector('.jdgm-average-rating');
      const ratingLabel = source?.querySelector('[aria-label]')?.getAttribute('aria-label') || '';
      const rating = ratingLabel.match(/[0-9]+(?:\.[0-9]+)?/)?.[0];
      const count = source?.querySelector('.jdgm-reviews-count')?.textContent.trim();
      const carousel = source?.closest('.shopify-section');
      if (carousel) summary.href = '#' + carousel.id;
      if (rating && count && Number(count.replace(/,/g, '')) > 0) {
        summary.textContent = summary.dataset.ratingTemplate.replace('__RATING__', rating).replace('__COUNT__', count);
      }
      if (source && !sourceObserver) {
        sourceObserver = new MutationObserver(update);
        sourceObserver.observe(source, { childList: true, subtree: true, characterData: true });
      }
      return Boolean(source);
    };
    if (update()) return;
    const finder = new MutationObserver(() => { if (update()) finder.disconnect(); });
    finder.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => finder.disconnect(), 30000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('change', (event) => {
  const productInfo = event.target.closest('product-info');
  if (!productInfo || !event.target.closest('.product__variants')) return;
  const note = productInfo.querySelector('.jdm-white-sale-note');
  if (!note) return;
  const selected = productInfo.querySelector('.product__variants input:checked, .product__variants select');
  note.hidden = !(note.dataset.whiteSale === 'true' && selected && selected.value === 'White');
});

  } catch(e) { console.error(e); }
})();
})();
